module.exports = __webpack_public_path__ + "img/Monte_Kope_4.a3b9d226.jpg";